// Single source of truth for the app version and the "What's new" changelog.
//
// Add new releases to the TOP of this array. The newest entry's `version` is
// what the version badge shows and what drives the "there's something new"
// highlight (see components/VersionBadge). `date` and `title` are optional.

export const CHANGELOG = [
  {
    version: "1.3",
    date: "June 2026",
    title: "Keyboard shortcuts",
    changes: [
      "Move through your flashcards with the arrow keys, and press Space or Enter to flip a card.",
      "Press “/” to jump to the search bar from anywhere, and Esc to clear it.",
      "On a definition page, press “n” to jump straight to the nouns.",
      "Added dictionary entries that were previously missing, so more roots now turn up in search.",
    ],
  },
  {
    version: "1.2",
    date: "June 2026",
    title: "Better flashcards & smarter search",
    changes: [
      "Organise flashcards into named collections, with sorting and the transliteration shown on each card.",
      "A new Settings page.",
      "Type a conjugated verb or derived word — like مكتوب — and Hans Wehr automatically suggests the root it comes from (كتب), so you don’t need to know the root yourself.",
      "Search now forgives typos and ignores harakaat (diacritics), powered by a more accurate native-Arabic root engine.",
      "Tap the Hans Wehr logo to return home, and pages now open scrolled to the top.",
    ],
  },
  {
    version: "1.1",
    date: "May 2026",
    title: "Sign in, sync & a guided start",
    changes: [
      "Sign in with Google to back up and sync your bookmarks and flashcards across devices.",
      "A guided walkthrough to help you find your way around.",
      "Smoother animations and transitions, a redesigned desktop layout, and a more responsive experience on mobile.",
      "A clearer typing guide and “scroll to top” buttons on every screen.",
      "Search bars no longer autocorrect or auto-capitalise what you type.",
    ],
  },
];

// The version shown in the badge — always the most recent release.
export const APP_VERSION = CHANGELOG[0].version;
